import React, { useEffect, useState } from 'react';

import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import TypographyUI from '../../components/TypographyUI';
import { CompanyServices } from '../../services/companies';
import useStore from '../../store/store';
import { companyHistoryStatuses } from '../../constants/conpanies';
import { formatUTCDate } from '../../helpers';
import createEditOrganization from "../../components/Organization/CreateEditOrganization";

const CreditsHistory = () => {
  const [creditsData, setCreditsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const {selectedOrganizationId} = useStore(
      (store) => store
  );

  useEffect(() => {
    const getCompanyCreditHistory = async () => {
      if (!selectedOrganizationId) {
        setLoading(false);
        return;
      }
      try {
        setLoading(true);
        setError(null);
        const response = await CompanyServices.getCompanyCreditHistory(
            selectedOrganizationId
        );
        setCreditsData(response.data.data);
      } catch (e) {
        console.error('Erreur lors de la récupération des crédits:', e);
        setError('Impossible de charger les données');
      } finally {
        setLoading(false);
      }
    };

    getCompanyCreditHistory();
  }, [selectedOrganizationId]);
  if (loading) {
    return (
        <Box>
          Chargement ....
        </Box>
    );
  }
  if (error) {
    return (
        <Box>
          Pb lors du chargement
        </Box>
    );
  }
  // SPACK console.log('creditsData',creditsData);
  return (
      <Box>
        <TypographyUI
            variant="h6"
            align="left"
            marginBottom="10px"
        >
          Historique des crédits
        </TypographyUI>

        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow className="green-border">
                <TableCell>Période en cours</TableCell>
              <TableCell>{ (creditsData.contract_type  === 'monthly') ? 'Volume contractuel mensuel' : (creditsData.contract_type  === 'date_range_token') ? 'Tokens en début de période' : 'Crédits' } </TableCell>
              <TableCell>{ (creditsData.contract_type  === 'monthly') ? 'Volume consommés mensuel' : (creditsData.contract_type  === 'date_range_token') ? 'Tokens consommés' : 'Consommation' } </TableCell>

                <TableCell>Statut du contrat</TableCell>
                <TableCell>Mois de fin de contrat</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {creditsData?.credits_history.map((row, index, arr) => (
                  <TableRow className="green-border" key={row.month}>
                    <TableCell className="green-border">{row.month}</TableCell>
                    <TableCell className="green-border">
                      {row.monthly_authorized_credits}
                    </TableCell>
                    <TableCell className="green-border">
                      {row.credits_used}
                    </TableCell>
                    <TableCell className="green-border">
                      {index === arr.length - 1
                          ? companyHistoryStatuses.current
                          : companyHistoryStatuses.closed}
                    </TableCell>
                    <TableCell>
                      {row?.dateEnd
                          ? formatUTCDate(creditsData.contract_end)
                          : ''}
                    </TableCell>
                  </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
  );

}

export default CreditsHistory;
